export const getLeagueNameProps = (sel) => {
    return {
        phrase: sel.leagueName
    };
};
//# sourceMappingURL=getLeagueNameProps.js.map